// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"242":"c8c43932ff44c8e2","975":"bd99b674ed8e17f2"}[chunkId] + ".js";
};